<template>
    <layout>
        <!-- <breadcrumb title="information" current="Blog Three Column" /> -->

        <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
            <div style="position: relative;"> <img style="min-width: 1400px;"
                    src="@/assets/images/bg/img_zixun_toutu@2x.png" alt="">
                <div
                    style="position: absolute;top: 50%;color: #fff;left: 50%;transform:translate(-50%, -50%);max-width: 80vw;">
                    <h1 style="text-align: center;">{{ $t('information.name') }}</h1>
                    <h6 style="margin-top: 1.25rem;">{{ $t('information.poster') }}</h6>
                </div>
                <div :style="isMobile() ? 'display: flex;justify-content: center;' : ''"
                    style="max-width:1400px;padding: 20px;background: #1E242B;color: #fff;margin-bottom: 30px;">{{
                        formatLocalTime().dateStr
                    }}</div>

            </div>

        </div>
        <a class="container1" v-for="(blog, index) in filteredRows" :key="`blog-${index}`">
            <!-- 左侧时间区域 -->
            <div class="time-column">
                <div class="time">{{ blog.create_date }}</div>
                <div class="dot"></div>
                <div class="line"></div>
            </div>

            <!-- 中间内容区域 -->
            <div class="content-column" >
                <a target="_blank" :href="blog.fullurl" class="title">{{removeRichTextTags( blog.title) }}</a>
                <div class="desc">{{ removeRichTextTags(blog.description) }}</div>
                <div class="tags">
                    <button class="tag" v-if="blog.tags">{{ blog.tags }}</button>
                </div>
                <div class="icon">
                    <div class="icon_1"><img style=" width: 25px;"
                            src="@/assets/images/icons/icon_zixun_dianzan_nor@3x.png" alt=""> &nbsp{{ blog.likes }}
                    </div>
                    <div class="icon_1"><img style=" width: 25px;" src="@/assets/images/icons/icon_zixun_pinglun@3x.png"
                            alt=""> &nbsp{{ blog.comments }}</div>
                    <!-- <div><img  src="@/assets/images/icons/icon_zixun_liulan@3x.png" alt="">{{ blog.description }}</div> -->
                </div>
            </div>

            <!-- 右侧按钮区域 -->
            <div class="btn-column" v-if="!isMobile()">
                <a :href="blog.fullurl" target="_blank" class="more-btn">{{ $t('information.more') }}</a>
                <img style="margin-left: 10px;" src="@/assets/images/icons/icon_zixun_more@2x.png" alt="">
            </div>
        </a>
        <div class="row" style="margin-bottom: 20rem;">
            <div v-if="isMobile()" style="display: flex;justify-content: space-around;">
                <div style="background: #FFC107;width: 80px;height: 30px;border-radius: 8px;display: flex;justify-content: center;align-items: center;color: #666;"
                    @click="BackToHome">{{ $t('information.homePage') }}</div>
                <div style="background: #FFC107;width: 80px;height: 30px;border-radius: 8px;display: flex;justify-content: center;align-items: center;color: #666;"
                    v-if="page != 1" @click="PreviousPage">{{ $t('information.PreviousPage') }}</div>
                <div style="background: #FFC107;width: 80px;height: 30px;border-radius: 8px;display: flex;justify-content: center;align-items: center;color: #666;"
                    @click="NextPage">{{ $t('information.NextPage') }}</div>
            </div>
            <div v-else class="col-lg-12" data-sal="slide-up" data-sal-delay="550" data-sal-duration="800">
                <blog-pagination :scrollControl="true" :itemsPerPage="10" :currentPage="page" :totalItems="total"
                    @paginatedData="paginatedData" @pageChanged="handlePageChange" />
            </div>
        </div>

        <!-- <div class="rn-blog-area rn-section-gapTop">
            <div class="container">
                <div class="row g-5">
                    <template v-for="(blog, index) in filteredRows" :key="`blog-${index}`">
                        <div class="col-lg-4 col-md-6 col-12">
                            <blog-card :blog="blog" />
                        </div>
                    </template>
</div>

</div>
</div> -->
    </layout>
</template>

<script>
import Pagination from '@/components/pagination/pagination'
import BlogCard from '@/components/blog/BlogCard1'
import Breadcrumb from '@/components/breadcrumb/Breadcrumb'
import Layout from '@/components/layouts/Layout'
import SalScrollAnimationMixin from '@/mixins/SalScrollAnimationMixin'
import BlogMixin from '@/mixins/BlogMixin'
import BlogPagination from '@/components/pagination/BlogPagination1'

export default {
    name: 'BlogThreeColumn',
    components: { BlogPagination, Pagination, BlogCard, Breadcrumb, Layout },
    mixins: [SalScrollAnimationMixin, BlogMixin],
    data() {
        return {
            filteredRows: '',
            pageStart: '',
            countOfPage: '',
            page: '1',
            total: "",

        }
    },
    mounted() {
        this.getMetadata()
    },
    methods: {
        removeRichTextTags(richText, handleEntities = true, trimWhitespace = true) {
			  // 处理空值/非字符串情况
			  if (typeof richText !== 'string' || richText === '') {
			    return '';
			  }
			
			  // 第一步：移除所有 HTML 标签（包括自闭合标签、带属性的标签）
			  let plainText = richText.replace(/<[^>]*>/g, '');
			
			  // 第二步：可选处理 HTML 实体（解决&nbsp;、&lt; 等转义字符问题）
			  if (handleEntities) {
			    const entityMap = {
			      '&nbsp;': ' ',
			      '&lt;': '<',
			      '&gt;': '>',
			      '&amp;': '&',
			      '&quot;': '"',
			      '&apos;': "'",
			      '&copy;': '©',
			      '&reg;': '®'
			    };
			    // 遍历替换常见实体
			    plainText = plainText.replace(/&[a-z]+;/g, (match) => entityMap[match] || match);
			  }
			
			  // 第三步：可选去除多余空白（合并多个空格/换行/制表符为单个空格，首尾去空）
			  if (trimWhitespace) {
			    plainText = plainText.replace(/\s+/g, ' ').trim();
			  }
			
			  return plainText;
			},
        isMobile() {
            // 匹配常见移动设备的 User-Agent
            const mobileReg = /Android|iPhone|iPad|iPod|iOS|Windows Phone|BlackBerry|SymbianOS|Opera Mini|UC Browser Mini/i;
            return mobileReg.test(navigator.userAgent);
        },
        BackToHome() {
            this.page = 1,
                this.getMetadata()
        },
        PreviousPage() {
            this.page--,
                this.getMetadata()
        },
        NextPage() {
            this.page++,
                this.getMetadata()
        },
        isMobile() {
            // 匹配常见移动设备的 User-Agent
            const mobileReg = /Android|iPhone|iPad|iPod|iOS|Windows Phone|BlackBerry|SymbianOS|Opera Mini|UC Browser Mini/i;
            return mobileReg.test(navigator.userAgent);
        },
        formatLocalTime() {
            const now = new Date();
            const weekdays = [this.$t('information.Sunday'), this.$t('information.Monday'), this.$t('information.Tuesday'),
            this.$t('information.Wednesday'), this.$t('information.Thursday'), this.$t('information.Friday'), this.$t('information.Saturday')];

            // 提取本地时区组件
            const month = now.getMonth() + 1;
            const day = now.getDate();
            const weekday = weekdays[now.getDay()];
            const hour = now.getHours().toString().padStart(2, "0"); // 补零为两位数
            const minute = now.getMinutes().toString().padStart(2, "0");

            // 格式1：仅日期（对应你的需求）
            const dateStr = `${this.$t('information.today')}  ${month}${this.$t('information.moon')}${day}${this.$t('information.day')} ${weekday}`;
            // 格式2：完整日期时间

            return { dateStr };
        },
        handlePageChange(pageNum) {
            this.page = pageNum
            this.getMetadata()

            //   this.currentPage = pageNum;
            //   this.fetchData(pageNum);
        },
        getMetadata() {
            fetch('https://apph5.matrixpower.club/addons/cms/api.archives/index?&channel=-1&model=1&page=' + this.page, {
                method: 'GET', // 默认就是GET，可省略
                headers: {
                    'Content-Type': 'application/json', // 声明数据格式
                    'Authorization': 'Bearer xxxxxxxx' // 身份令牌（如登录后获取）
                }
            })
                .then(response => {
                    if (!response.ok) throw new Error('请求失败');
                    return response.json(); // 解析JSON格式的响应数据
                })
                .then(data => {
                    this.filteredRows = data.data.pageList.data
                    this.total = data.data.pageList.total

                    console.log('接口返回数据：', this.filteredRows); // 处理数据（如渲染到页面）
                })
                .catch(error => {
                    console.error('错误：', error); // 处理错误（如网络异常、权限不足）
                });
        },
        // /api.archives/index
        paginatedData(filteredRows, pageStart, countOfPage) {
            console.log(filteredRows, pageStart, countOfPage);
            this.filteredRows = filteredRows;
            this.page = pageStart / 10;
            this.getMetadata()
            this.countOfPage = countOfPage;
        }
    }
}
</script>
<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Microsoft Yahei", sans-serif;
}




@media (min-width: 769px) and (max-width: 1440px) {
    .info-card {
        max-width: calc(50% - 1vw);
        /* 每行2个卡片 */
    }
}

/* 容器样式：深蓝色背景，整体布局 */
.container1 {
    display: flex;
    align-items: flex-start;
    /* background-color:#27313D ; */
    /* 深蓝色背景 */
    color: #fff;
    /* padding: 20px; */
    padding-top: 0;
    padding-bottom: 0;
    max-width: 1400px;
    width: 90vw;
    margin: 0 auto;
    /* margin-top: 30px;
    margin-bottom: 30px; */

}

/* 左侧时间区域 */
.time-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 20px;
    position: relative;
    flex-wrap: nowrap;
    /* min-width: 15.25rem; */
}

.time {
    font-size: 14px;
    font-weight: bold;
    color: #FFC107;
    /* 黄色时间 */
    margin-bottom: 10px;
}

.dot {
    width: 10px;
    height: 10px;
    background-color: #FFC107;
    border-radius: 50%;
    /* margin-bottom: 100px; */
    /* 竖线长度可调整 */
}

.line {
    width: 1px;
    height: 120px;
    background-color: #4d4d4d;
    /* position: absolute;
    top: 50px;
    left: 5px; */
    margin: 0 auto;
}

/* 中间内容区域 */
.content-column {
    flex: 1;
}

.title {
    font-size: 16px;
    margin-bottom: 15px;
    width: 100%;
    max-width: 50vw;
    /* white-space: nowrap; */
    /* 强制不换行 */
    overflow: hidden;
    /* 溢出内容隐藏 */
    text-overflow: ellipsis;
    /* margin-bottom: 10px; */
    /* 显示省略号 */
}

.desc {
    font-size: 14px;
    color: #BDC3C7;
    margin-bottom: 20px;
    max-width: 45vw;
    white-space: nowrap;
    /* 强制不换行 */
    overflow: hidden;
    /* 溢出内容隐藏 */
    text-overflow: ellipsis;
    margin-top: 10px;
}

.tags {
    display: flex;
    gap: 15px;
}

.icon {
    width: 200px;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    align-items: center;
}

.icon_1 {
    display: flex;
    align-items: center;
}

.tag {
    background-color: #1e242b;
    color: #BDC3C7;
    padding: 8px 15px;
    border: none;
    cursor: pointer;
    max-width: 30rem;
}

/* 右侧按钮区域 */
.btn-column {
    display: flex;
    align-items: center;
    margin-left: 20px;
}

.more-btn {
    display: flex;
    align-items: center;
    color: #fff;
    text-decoration: none;
    font-size: 14px;
}

/* .more-btn::after {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid #fff;
    border-radius: 50%;
    margin-left: 5px;
} */

/* 响应式适配 */
@media (max-width: 768px) {
    .container {
        flex-direction: column;
        align-items: flex-start;
    }

    .time-column {
        flex-direction: column;
        align-items: center;
        /* justify-content: center; */
        /* margin-bottom: 15px; */
        min-width: 50px;
    }

    .btn-column {
        display: none;
    }

    .time {
        /* margin-right: 10px; */
        margin-bottom: 0;
    }

    .dot {
        margin-bottom: 0;
        /* margin-right: 10px; */
    }

    .line{
        height: 140px;
    }

    .btn-column {
        margin-left: 0;
        margin-top: 20px;
    }
}
</style>